import {SectionView} from '../../ui_canvas_engine/SectionView'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {CityImprovementTypes} from '@colonist/game-states'

export class UIGameCityImprovementProgressTrackerSquareView extends SectionView {
    private readonly cityImprovementType: CityImprovementTypes
    readonly progressLevel: number
    private readonly squareView: SpriteView

    constructor(x: number, y: number, size: number, container: PIXI.Container, cityImprovementType: CityImprovementTypes, progressLevel: number) {
        super(x, y, size, size, container, true)

        this.cityImprovementType = cityImprovementType
        this.progressLevel = progressLevel

        const inactiveTexture = this.getInactiveTexture()
        const scaleToHideOverflow = 0.98
        this.squareView = new SpriteView(0, 0, size * scaleToHideOverflow, size * scaleToHideOverflow, this, inactiveTexture)
        this.squareView.centerXInParent()
        this.squareView.centerYInParent()

        const frameTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_frame)
        const squareFrame = new SpriteView(0, 0, size, size, this, frameTexture)
        squareFrame.centerXInParent()
        squareFrame.centerYInParent()
    }

    setActiveTexture() {
        const activeTexture = this.getActiveTexture()
        this.squareView.texture = activeTexture
    }

    setInactiveTexture() {
        const inactiveTexture = this.getInactiveTexture()
        this.squareView.texture = inactiveTexture
    }

    private getActiveTexture(): PIXI.Texture {
        switch(this.cityImprovementType) {
            case CityImprovementTypes.Politics: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_active_politics)
            case CityImprovementTypes.Trade: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_active_trade)
            case CityImprovementTypes.Science: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_active_science)
        }
    }

    private getInactiveTexture(): PIXI.Texture {
        switch(this.cityImprovementType) {
            case CityImprovementTypes.Politics: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_inactive_politics)
            case CityImprovementTypes.Trade: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_inactive_trade)
            case CityImprovementTypes.Science: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_square_inactive_science)
        }
    }
}
